import React from 'react';
import PropTypes from 'prop-types';

import { getSrcString } from '../helpers/getSrcStrings';

import styles from './HpRespCollectionsModuleItemOld.scss';

function HpRespCollectionsModuleItemOld({ item, onClick }) {
    const { isLinkable, title, imageUrl, link } = item;

    return (
        <a
            className={styles.link}
            href={link}
            onClick={onClick}
            data-tn="collections-item-link"
            rel={isLinkable ? null : 'nofollow'}
        >
            <div className={styles.imageWrapper}>
                <img
                    className={styles.image}
                    src={getSrcString({ url: imageUrl })}
                    alt={title}
                    data-tn="collections-item-image"
                />
            </div>
            <span className={styles.title} data-tn="collections-item-title">
                {title}
            </span>
        </a>
    );
}

HpRespCollectionsModuleItemOld.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        link: PropTypes.string,
        isLinkable: PropTypes.bool,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespCollectionsModuleItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespCollectionsModuleItemOld };
